import { QueryHookOptions } from '@apollo/client';
import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import {
  LoyaltyEventsListQuery,
  LoyaltyEventsListQueryVariables,
  OfferFilter,
  useLoyaltyEventsListQuery,
} from '@occc/graphql';

type GetLoyaltyEventsListArgs = {
  filter: OfferFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions<LoyaltyEventsListQuery, LoyaltyEventsListQueryVariables>;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

export const useGetLoyaltyEventsList = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: GetLoyaltyEventsListArgs) => {
  const response = usePaginatedQuery(
    useLoyaltyEventsListQuery,
    'offers.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...baseOptions,
      variables: {
        ...baseOptions?.variables,
        filter,
      },
    },
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: response.data ? response.data.offers.edges.map((item) => item.node) : response.data,
  };
};
